export const calc = (property: string, expression: string, fallback: string): string => `
    ${property}: ${fallback};
    ${property}: -webkit-calc(${expression});
    ${property}: calc(${expression});
`;
